// third-party
import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import labReducer from './slices/lab/lab';
import userReducer from './slices/user';
import customerReducer from './slices/customer/customer';
import branchReducer from './slices/branch/branch';
import testRequests from './slices/testRequest/testRequests';
import testTemplateReducer from './slices/testTemplate/testTemplate.slice';
import menuReducer from './slices/menu';
import formNavigateReducer from './slices/formNavigate/formNavigateSlice';
import generatedSampleIdReducer from './slices/generatedSampleId/generatedSampleId';
import trackingPickupReducer from './slices/pickupTracking/pickupTracking.slice';
import gaiapodReducer from './slices/gaiapod/gaiapod.slice';
import mapsReducer from './slices/maps/mapSlice';
// Config
import lookupDetailReducer from './slices/lookMaster/lookupDetailsSlice.selector';
import costingReducer from './slices/costingInvoicing/costingInvoicing.slice';
import pricingReducer from './slices/pricingList/pricingList.slice';
import invoiceReportsReducer from './slices/invoiceReports/invoiceReports.slice';
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer,
    customer: customerReducer,
    branch: branchReducer,
    lookupDetails: lookupDetailReducer,
    generatedSampleId: generatedSampleIdReducer,
    testRequests,
    testTemplate: testTemplateReducer,
    lab: labReducer,
    costingInvoicing: costingReducer,
    pricing: pricingReducer,
    invoiceReports: invoiceReportsReducer,
    trackingPickup: trackingPickupReducer,
    gaiapod: gaiapodReducer,
    maps: mapsReducer,
    //  test: myCall(),
    // if error dont navigate
    formNavigate: formNavigateReducer
});

export default reducer;
